import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/shared/ui/dialog';
import type { UsageFilter } from '../api/use-ai-admin';
import { UsageList } from './usage-list';

interface UsageDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  filter: UsageFilter;
}

export function UsageDialog({ open, onOpenChange, title, description, filter }: UsageDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="wide">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description ? <DialogDescription>{description}</DialogDescription> : null}
        </DialogHeader>
        <UsageList filter={filter} enabled={open} />
      </DialogContent>
    </Dialog>
  );
}
